<div class="dialogue-content">
    <div class="mat-dialogue-header">
        <a class="close-btn" mat-dialog-close><i class="ri-close-fill"></i></a>
    </div>
    <mat-dialog-content>
        <div class="text-center">
            <form novalidate>
                <img src="../../../assets/images/change-status.svg" class="mb-4 m-auto d-table" />
                <h5 class="text-primary">Change Status</h5>
                <p class="fs-6 mb-0">
                    Are you sure you want to
                    <span class="{{ title === 'Active' ? 'active-title' : 'inactive-title' }}">
                        {{ title }}
                    </span> this {{type}}?
                </p>
                <span class="fw-bolder">{{ action }}</span>
                <div class="d-flex align-items-center mt-4 flex-wrap justify-content-center gap-3">
                    <button matButton="filled" type="button" class="dialog-btn-primary"
                        (click)="confirmStatusChange()">Yes</button>
                    <button matButton="filled" type="button" class="dialog-btn-secondary"
                        (click)="onSecondaryButtonClick()">{{ secondaryButtonText }}</button>
                </div>
            </form>
        </div>
    </mat-dialog-content>
</div>